import { useEffect } from "react";
import { useLocation } from "@/lib/router-compat";
import { initAnalytics, trackPageView } from "@/lib/analytics";
import { initMetaPixel } from "@/lib/metaPixel";
import { addBreadcrumb } from "@/lib/sentry";
import { captureUtm } from "@/lib/utmAttribution";

/**
 * Loads Google analytics on the published domain and emits a clean
 * page-view event on every route change so connected analytics tools receive a
 * consistent navigation stream in a SPA.
 *
 * Policy (2026-08-04): optional tags are consent-gated. Google Consent Mode
 * defaults to `denied` in index.html; accepting in the cookie banner grants
 * storage and triggers pixel loading here. Rejecting keeps them off.
 * Renders nothing. Must live inside the router.
 */
export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
    void initMetaPixel();
  }, []);




  useEffect(() => {
    // Navigation breadcrumb for error telemetry (no-op unless Sentry is on).
    captureUtm(location.search);
    addBreadcrumb(`navigate ${location.pathname}`, { search: location.search });
    // Defer so document.title (set via useSEO) is up to date. This pushes a
    // `page_view` event to the GTM dataLayer on every SPA navigation.
    // Skip automated browsers and known crawlers so reports reflect real people.
    const ua = navigator.userAgent || "";
    if (navigator.webdriver || /bot\b|crawl|spider|slurp|headlesschrome|lighthouse|facebookexternalhit|bingpreview/i.test(ua)) return;
    const id = window.setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 0);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
}
